export const SCOPES = {
  app: 'app:eng short',
} as const;

export const ROLES = {
  admin: 'eng:admin',
  panelAdmin: 'eng:panel_admin',
  panelFinance: 'eng:panel_finance',
  panelManager: 'eng:panel_manager',
  panelSupport: 'eng:panel_support',
  panelUserSupport: 'eng:panel_user_support',
  userSupport: 'eng:user_support',
} as const;

export const RESOURCES = {
  activation: {
    id: 'activation',
    actions: {
      direct: 'direct',
    },
  },
  bulkban: {
    id: 'bulkban',
    actions: {
      create: 'create',
    },
  },
  company: {
    id: 'company',
    actions: {
      view: 'view',
      create: 'create',
    },
  },
  panelist: {
    id: 'panelist',
    actions: {
      view: 'view',
      ledger: 'ledger',
      banunban: 'banunban',
      import: 'import',
      close: 'close',
    },
  },
  pm: {
    id: 'pm',
    actions: {
      view: 'view',
      create: 'create',
      ustatus: 'ustatus',
      update: 'update',
      upcodes: 'upcodes',
      upcocodes: 'upcocodes',
      viewcodes: 'vwcodes',
      viewcocodes: 'vwcocodes',
    },
  },
  panel: {
    id: 'panel',
    actions: {
      view: 'view',
      psettings: 'psettings',
      pincentiv: 'pincentiv',
      create: 'create',
      posettings: 'posettings',
      export: 'export',
    },
  },
  marketing: {
    id: 'marketing',
    actions: {
      viewcamp: 'viewcamp',
      editcamp: 'editcamp',
      viewtmpl: 'viewtmpl',
      edittmpl: 'edittmpl',
    },
  },
  translat: {
    id: 'translat',
    actions: {
      view: 'view',
      create: 'create',
      update: 'update',
      delete: 'delete',
    },
  },
  report: {
    id: 'report',
    actions: {
      view: 'view',
    },
  },
  suppliers: {
    id: 'supplier',
    actions: {
      viewsup: 'viewsup',
      editsup: 'editsup',
    },
  },
  incentive: {
    id: 'pmp',
    actions: {
      pmpEdit: 'edit',
    },
  },
  lead: {
    id: 'lead',
    actions: {
      batch: 'batch',
    },
  },
  blocklist: {
    id: 'blocklist',
    actions: {
      edit: 'edit',
    },
  },
  payout: {
    id: 'bpayment',
    actions: {
      edit: 'edit',
    },
  },
  targetedSampling: {
    id: 'sampling',
    actions: {
      view: 'target',
      automation: 'automation',
    },
  },
  experiments: {
    id: 'panel',
    actions: {
      view: 'pexpincen',
    },
  },
  profiling: {
    id: 'profiler',
    actions: {
      view: 'view',
      edit: 'edit',
    },
  },
} as const;
